import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableBody,
} from '@mui/material';

import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../components/common/Table';

export default function TerytTable(props) {
  return (
    <>
      <Grid container sx={{ mt: 4, mb: 8 }}>
        <Grid item xs={12} ref={props.cropsStructureTableRef}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="terytTable">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Numer teryt</StyledTableCell>
                  <StyledTableCell align="center">
                    Powierzchnia (ha)
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Forma użytkowania gruntu
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data
                  ?.sort((a, b) => a.id - b.id)
                  .map((row) => (
                    <StyledTableRow key={row.id + '_teryt'}>
                      <StyledTableCell component="th" scope="row">
                        {row.teryt}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.area}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.owned ? 'Własność' : 'Dzierżawa'}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
}
